import { MapTo } from '@adobe/aem-react-editable-components';
import SetupStepsSection, { SetupStepsSectionEditConfig } from './SetupStepsSection';

export default MapTo('cob-corp-acquisition/components/creditonebank/setup-steps-section')(SetupStepsSection, SetupStepsSectionEditConfig);